import { getInjector } from '../../utils/getInjector';
import { getTrackItem, flatCartItemsWithAddon } from './utils';
import slEventBus, { eventMetaMap } from '../../../../utils/slEventBus';

/**
 * @param {object} payload
 * @param {string} payload.itemId - The id of the item that was updated.
 * @param {object} payload.currentCartData - The cart data after update
 * @param {object} [payload.trackerOptions] - The options for tracking (optional)
 * @param {object} payload.cartData - raw cart data after quantity update
 */
export const onTrackUpdateItem = async (payload) => {
  const { itemId, currentCartData, trackerOptions = {}, cartData } = payload;
  const injector = await getInjector();
  const trackerService = injector.get('trackerService');
  const cartService = injector.get('cartService');

  const flattenedItems = flatCartItemsWithAddon(currentCartData.items);
  const updatedItem = flattenedItems.find((item) => item.id === itemId);
  const trackItem = getTrackItem(
    updatedItem.product_id,
    updatedItem.variation_id,
    updatedItem.type,
    flattenedItems,
  );

  // shoplytics
  cartService.tracking(trackerService.userActionTypes.UPDATE_ITEM, trackItem, {
    scope: 'shop',
    event_category: 'Cart',
    ...trackerOptions,
  });

  // for storefront sdk
  slEventBus.emit(eventMetaMap.cart.itemUpdated.name, cartData);
};
